import { __exports as getRenderProperties } from "./index150.js";
import { __require as requireGetOptionsFromElement } from "./index151.js";
import { __require as requireRenderers } from "./index152.js";
import { __require as requireExceptions } from "./index133.js";
var hasRequiredGetRenderProperties;
function requireGetRenderProperties() {
  if (hasRequiredGetRenderProperties) return getRenderProperties;
  hasRequiredGetRenderProperties = 1;
  Object.defineProperty(getRenderProperties, "__esModule", {
    value: true
  });
  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _getOptionsFromElement = requireGetOptionsFromElement();
  var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);
  var _renderers = requireRenderers();
  var _renderers2 = _interopRequireDefault(_renderers);
  var _exceptions = requireExceptions();
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getRenderProperties$1(element) {
    if (typeof element === "string") {
      return querySelectedRenderProperties(element);
    } else if (Array.isArray(element)) {
      var returnArray = [];
      for (var i = 0; i < element.length; i++) {
        returnArray.push(getRenderProperties$1(element[i]));
      }
      return returnArray;
    } else if (typeof HTMLCanvasElement !== "undefined" && element instanceof HTMLImageElement) {
      return newCanvasRenderProperties(element);
    } else if (element && element.nodeName && element.nodeName.toLowerCase() === "svg" || typeof SVGElement !== "undefined" && element instanceof SVGElement) {
      return {
        element,
        options: (0, _getOptionsFromElement2.default)(element),
        renderer: _renderers2.default.SVGRenderer
      };
    } else if (typeof HTMLCanvasElement !== "undefined" && element instanceof HTMLCanvasElement) {
      return {
        element,
        options: (0, _getOptionsFromElement2.default)(element),
        renderer: _renderers2.default.CanvasRenderer
      };
    } else if (element && element.getContext) {
      return {
        element,
        renderer: _renderers2.default.CanvasRenderer
      };
    } else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === "object" && !element.nodeName) {
      return {
        element,
        renderer: _renderers2.default.ObjectRenderer
      };
    } else {
      throw new _exceptions.InvalidElementException();
    }
  }
  function querySelectedRenderProperties(string) {
    var selector = document.querySelectorAll(string);
    if (selector.length === 0) {
      return void 0;
    } else {
      var returnArray = [];
      for (var i = 0; i < selector.length; i++) {
        returnArray.push(getRenderProperties$1(selector[i]));
      }
      return returnArray;
    }
  }
  function newCanvasRenderProperties(imgElement) {
    var canvas = document.createElement("canvas");
    return {
      element: canvas,
      options: (0, _getOptionsFromElement2.default)(imgElement),
      renderer: _renderers2.default.CanvasRenderer,
      afterRender: function afterRender() {
        imgElement.setAttribute("src", canvas.toDataURL());
      }
    };
  }
  getRenderProperties.default = getRenderProperties$1;
  return getRenderProperties;
}
export {
  requireGetRenderProperties as __require
};
//# sourceMappingURL=index130.js.map
